import React from 'react';
import PropTypes from 'prop-types';
import Row from 'components/UI/Layout/Row';
import Col from 'components/UI/Layout/Col';

function Skeleton({
    type, color, className, height, size, margin,
})
{
    return (
        <div className={`tw-flex tw-flex-auto tw-flex-col ${className}`}>
            {type === 'title' && (
                <div className={`tw-w-full ${height || 'tw-h-10'} ${margin || 'tw-mb-2 tw-mt-5'} tw-animate-pulse ${color}`}>&nbsp;</div>
            )}
            {type === 'box' && (
                <div className={`tw-w-full ${height || 'tw-h-20'} ${margin || 'tw-mb-2 tw-mt-5'} tw-animate-pulse ${color}`}>&nbsp;</div>
            )}
            {type === 'card' && (
                <>
                    <div className={`tw-flex tw-flex-row ${height || 'tw-h-40'} ${margin || 'tw-mb-2'}`}>
                        <div className={`tw-w-1/3 tw-mr-3 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className="tw-w-2/3 tw-flex-row">
                            <div className={`tw-w-4/5 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-1/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-2/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-2/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                            <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        </div>
                    </div>
                    <div className="tw-h-12">
                        <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-4/5 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                    </div>
                </>
            )}
            {type === 'list' && (
                <div className={`tw-flex tw-flex-row ${height || 'tw-h-40'} ${margin || 'tw-mb-2'}`}>
                    <div className="tw-w-2/3 tw-flex-row">
                        <div className={`tw-w-4/5 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-1/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-2/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-2/3 tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-full tw-h-4 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                    </div>
                </div>
            )}
            {type === 'table' && (
                <Col>
                    <Row className="tw-gap-3">
                        <div className={`tw-w-1/5 tw-h-9 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-1/5 tw-h-9 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-1/5 tw-h-9 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-1/5 tw-h-9 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                        <div className={`tw-w-1/5 tw-h-9 tw-mb-2 tw-animate-pulse ${color}`}>&nbsp;</div>
                    </Row>

                    {Array.from(Array(size ?? 6), (e, i) => (
                        <Row key={i}>
                            <div className={`tw-w-full tw-h-4 ${margin || 'tw-mb-2'} tw-animate-pulse ${color}`}>&nbsp;</div>
                        </Row>
                    ))}
                </Col>
            )}
        </div>
    );
}

Skeleton.defaultProps = {
    type: 'card',
    color: 'tw-bg-gray-300',
    size: null,
};

Skeleton.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.string,
    margin: PropTypes.string,
    size: PropTypes.number,
    type: PropTypes.oneOf(['card', 'list', 'table', 'title', 'box']),
};

export default Skeleton;
